import { NotificationPage as Data } from '@/typings/api/NotificationPage'
import { Model, createMessages } from '@/helpers/Model'


export class NotificationPageModel extends Model<Data> {
    public static readonly page_title = createMessages({
      create: 'Добавить страницу сайта',
      edit: 'Редактировать страницу сайта',
      view: (data: NotificationPageModel) => 'Страница «{name}»'
        .replace('{name}', data.name || '...'),
      list: 'Страницы сайта',
    });

    public static readonly modal_delete = createMessages({
      ...Model.modal_delete,
      delete: (data: NotificationPageModel) => 'Удаление страницы «{name}»'
        .replace('{name}', data.name || '...'),
    });

    public static getName(data: Data) {
      return data?.title ?? '...'
    }
}
